import ImageOne from "../img/poster1.jpg"
import img1 from "../img/products/img1.png"
import img2 from "../img/products/img2.png"
import img11 from "../img/products/img11.png"
import img12 from "../img/products/img12.png"
import img13 from "../img/products/img13.png"
import img21 from "../img/products/strange1.png"
import img22 from "../img/products/strange2.png"
import img23 from "../img/products/strange4.png"
import img24 from "../img/products/strange5.png"
import img25 from "../img/products/disney1.png"
import img26 from "../img/products/disney2.png"
import img27 from "../img/products/disney4.png"
import img28 from "../img/products/disney5.png"
import img29 from "../img/products/one2.png"
import img30 from "../img/products/one3.png"
import img31 from "../img/products/one4.png"
import img32 from "../img/products/one5.png"
import product1 from "../img/products/strange3.png"
import product2 from "../img/products/harry1.png"
import product3 from "../img/products/bts1.png"
import product4 from "../img/products/disney3.png"
import product5 from "../img/products/img5.png"
import product6 from "../img/products/one1.png"
import product7 from "../img/products/aespa1.png"
import product8 from "../img/products/oli1.png"
import logo1 from "../img/products/logo1.png"
import logo2 from "../img/products/logo2.png"
import logo3 from "../img/products/logo3.png"
import logo4 from "../img/products/logo4.png"
import logo5 from "../img/products/logo5.png"
import logo6 from "../img/products/logo6.png"
import logo7 from "../img/products/logo7.png"
import logo8 from "../img/products/logo8.png"

export const categories = [
  {
    id: 1,
    img: ImageOne,
    title: "Movies Collaboration",
  },
  {
    id: 2,
    img: "https://static.onecms.io/wp-content/uploads/sites/6/2021/10/11/BTS-BUTTER-Casetify.jpg",
    title: "Artist Collaborations",
  },
  {
    id: 3,
    img: "https://licensinginternational.org/wp-content/uploads/2020/05/Heinz.jpg",
    title: "Food Collaborations",
  },
];

export const people = [
   {
    id: 1,
    img: "https://wwd.com/wp-content/uploads/2017/10/sadie-sink-jg-03.jpg",
    name: "Sadie Sink",
    job: "American Actress",
    comment: "Such an awesome case. It's sturdy, the colors in the design are vibrant, and it is holding up better than any other case I've ever had to wear and tear. I also sanitize my phone fairly frequently with alcohol wipes and I haven't noticed that having any impact on the case itself."
  },
  {
    id: 2,
    img: "https://pbs.twimg.com/media/De2WSRJUwAAP7sm.jpg",
    name: "Park Seo Joon",
    job: "Korean male actor",
    comment: "Thank you for the amazing service. The products is even better than i expected.👍"
  },
  {
    id: 3,
    img: "https://c4.wallpaperflare.com/wallpaper/961/554/534/k-pop-iu-lee-ji-eun-singer-actress-hd-wallpaper-preview.jpg",
    name: "Lee Ji-Eun",
    job: "Korean singer-songwriter",
    comment: "It was easy and fun to customize my only phone case 🤩 There are so many cute cases and it's easy to check out!"
  },
  {
    id: 4,
    img: "https://lh3.googleusercontent.com/TOJUwoR-4bKat02zfWuoC_1X4YvqAxORO3ZiESE9gaM_ozwmcDTOY0HYlfVJ7XGv6gwZkMlladVcC2FVuaTWIveWEI-f7GD7nmm4lxDVS6otRSQ=w960-rj-nu-e365",
    name: "Kim Tae-Hyung",
    job: "Korean boy band Singer",
    comment: "Thank you for the amazing service. The products is even better than i expected.👍"
  },
  {
    id: 5,
    img: "https://upload.wikimedia.org/wikipedia/en/0/0f/Tom_Holland_as_Spider-Man.jpg",
    name: "Tom Holland",
    job: "British Actor",
    comment: "love the product so much website is easy to follow and simply just all good 😎"
  },
  {
    id: 6,
    img: "http://res.heraldm.com/content/image/2021/10/21/20211021000772_0.jpg",
    name: "Han So Hee",
    job: "Korean female actress",
    comment: "Thank you for the amazing service. The products is even better than i expected.👍"
  },
  {
    id: 7,
    img: "https://media.vanityfair.com/photos/580a0b41ceb79a6c5ca4c5ef/2:3/w_640,h_960,c_limit/benedict-cumberbatch-doctor-strange.jpg",
    name: "Doctor Strange",
    job: "Marvel superhero",
    comment: "Thank you for the amazing service. The products is even better than i expected.👍"
  }
];

export const sliderData = [
  {
    id: 1,
    bg: "000000",
    img: ImageOne,
    title: "Stranger Things X Casetify",
    desc: "The Gate is open... again! CASETiFY's first Co-Lab with groundbreaking Netflix's Stranger Things, marries '80s nostalgia with beloved motifs from the hit show. Explore the new collection inspired by iconic moments from Stranger Things, only at CASETiFY.",
  },
  {
    id: 2,
    bg: "000000",
    img: "https://pbs.twimg.com/media/FAdVTOgX0Ao_W8I?format=jpg&name=large",
    title: "BTS X Casetify",
    desc: "BTS made history with their song \"Butter\" and they're breaking new ground again with this new BTS | CASETiFY Butter tech collection! Join the crowd and deck your gear in BTS's legendary style.",
  },
  {
    id: 3,
    bg: "000000",
    img: "https://cdn-stamplib.casetify.com/cms/image/0a252979b21ac6f7c608848339d0f03d.png",
    title: "ONE PIECE Collabs",
    desc: "The Pirates Black Collection lineup includes items inspired by collectibles such as playing cards, plastic models, and stickers, as well as designs celebrating the release of the \"ONE PIECE FILM RED\" movie. Get your hands on tech accessories featuring popular characters and iconic motifs! iPhone 14 series will be available.",
  },
  {
    id: 4,
    bg: "000000",
    img: "https://cdn-stamplib.casetify.com/cms/image/2d6a340ba53ec798cc07b527575b91fd.png",
    title: "Harry Potter | Casetify",
    desc: "Discover the magic: CASETiFY invites you to embark on an enchanting adventure - inspired by the magical moments from the Harry Potter films. Explore the exclusive collection with accessories fit for wizards, witches and Muggles™️ alike.",
  }
]

export const productItems = [
    {
      id: 44,
      discount: "50 % off",
      img: "https://cdn-image02.casetify.com/usr/13458/22693458/~v50/21827724x2_iphone-14-pro__color_white_16004725.png.1000x1000-w.m80.jpg",
      name: 'Black Great Ramen',
      type: "Apple/Samsung",
      price: 100,
    },
    {
      id: 14,
      discount: "50 % off",
      img: img28,
      name: "Buzz Lightyear",
      type: "Apple/Samsung",
      price: 20,
    },
    {
      id: 18,
      discount: "50 % off",
      img: img30,
      name: "One Piece",
      type: "Apple/Samsung",
      price: 100,
    },
    {
      id: 55,
      discount: "50 % off",
      img: "https://cdn-image02.casetify.com/usr/29215/24959215/~v34/23602876x2_iphone13-pro__color_green_16005144.png.1000x1000-w.m80.jpg",
      name: "Barbed Worm",
      type: "Apple/Samsung",
      price: 50,
    },
    {
      id: 12,
      discount: "Recycled",
      img: img26,
      name: "Toy Story Collab",
      type: "Iphone13 pro",
      price: 50,
    },
    {
      id: 13,
      discount: 50,
      img: img27,
      name: "Jessie X Woody",
      type: "Apple/Samsung",
      price: 100,
    },
    {
      id: 14,
      discount: 50,
      img: product5,
      name: "Kakao Friends",
      type: "Iphone/Huawei",
      price: 55,
    },
    {
      id: 8,
      discount: 50,
      img: "https://cdn-image02.casetify.com/usr/13458/22693458/~v32/26151414x2_iphone-14-pro__color_black_16004813.png.1000x1000-w.m80.jpg",
      name: "Olivia Rodrigo",
      type: "Iphone/Huawei",
      price: 65,
    },
    {
      id: 19,
      discount: 50,
      img: img31,
      name: "One Piece",
      type: "Iphone/Huawei",
      price: 65,
    },
]

export const collab = [
  {
    id: 1,
    img: product1,
    logo: logo1,
    color: '#000',
    textc: '#FFFFFF',
    name: "Stranger Things",
    text: "Welcome back to Hawkins! The fans favourite science fiction horror drama is back. Our Hawkins friends are making their way through fighting the new evil, Vecna, that has emerged. Explore the new collection inspired by iconic moments now"
  },
  {
    id: 2,
    img: product3,
    logo: logo3,
    color: '#FFFF00',
    textc: '#000',
    name: "BTS Butter",
    text: "BTS made history with their song \"Butter\" and they're breaking new ground again with this new BTS | CASETiFY Butter tech collection! Join the crowd and deck your gear in BTS's legendary style."
  },
  {
    id: 3,
    img: product4,
    logo: logo4,
    color: '#0096FF',
    textc: '#fff',
    name: "Disney Toy Story",
    text: "Celebrate friendships that stand the test of time with our newest collection: Disney and Pixar's Toy Story. The collaboration keeps the magic of the Toy Story squad alive so you can relive their iconic adventures."
  },
  {
    id: 4,
    img: product5,
    logo: logo5,
    color: '#FFa500',
    textc: '#000',
    name: "Kakao Friends",
    text: "Surf's up and sun's out with the beloved characters from Kakao Friends! Deck your tech in cases starring Ryan and his friends as they hit the waves and catch some rays. Coast through summer knowing your phones are safe thanks to our technology."
  },
  {
    id: 5,
    img: product2,
    logo: logo2,
    color: '#000',
    textc: '#FFFFFF',
    name: "Harry Potter",
    text: "Inspired by the colors of the Wizarding World, our second exclusive collection matches our classic sticker designs with the four Hogwarts™ Houses and brings magical moments straight to your case"
  },
  {
    id: 6,
    img: product6,
    logo: logo6,
    color: '#C2DFFF',
    textc: '#FFFFFF',
    name: "One Piece",
    text: "The Pirates Black Collection lineup includes items inspired by collectibles such as playing cards, plastic models, and stickers, as well as designs celebrating the release of the \"ONE PIECE FILM RED\" movie."
  },
  {
    id: 7,
    img: product7,
    logo: logo7,
    color: '#000',
    textc: '#FFFFFF',
    name: "Aespa",
    text: "Aespa is bringing the next-level tech accessories collection into the mysterious world of Kwangya. Uncover the most savage piece, aespa exclusive collaboration collection!"
  },
  {
    id: 8,
    img: product8,
    logo: logo8,
    color: '#CF9FFF',
    textc: '#FFFFFF',
    name: "Olivia Rodrigo",
    text: "Featuring Olivia's iconic aesthetic, this collection serves as a reminder to keep it tough. Check out the range of cases in this collection that are powered by Re/CASETiFY."
  },
]

export const cases = [
  {
    id: 1,
    category: 'Iphone',
    collab: 'Stranger',
    img: img21,
    title: 'Stranger Things Light Theme',
    des: 'Basic Protect, Light Weight',
    price: 40,
  },
  {
    id: 2,
    category: 'Iphone',
    collab: 'Stranger',
    img: img22,
    title: 'Hellfire Club member',
    des: 'Basic Protect, Light Weight',
    price: 40,
  },
  {
    id: 3,
    category: 'Iphone',
    collab: 'Stranger',
    img: product1,
    title: 'Stranger Things Dark Theme',
    des: 'Strong Protect, Light Weight',
    price: 40,
  },
  {
    id: 4,
    category: 'Samsung Galaxy / Android',
    collab: 'Stranger',
    img: img23,
    title: 'Hawkins Kigh School',
    des: 'Strong Protect, Light Weight',
    price: 120,
  },
  {
    id: 5,
    category: 'Iphone',
    collab: 'Stranger',
    img: img24,
    title: 'Demogorgon Hunters Case',
    des: 'Strong Protect, Light Weight',
    price: 90,
  },
  {
    id: 6,
    category: 'Iphone',
    collab: 'Bts',
    img: img1,
    title: 'BTS Butter Sticker',
    des: 'Basic Protect, Light Weight',
    price: 40,
  },
  {
    id: 7,
    category: 'Iphone',
    collab: 'Bts',
    img: img2,
    title: 'Bts Butter Pancake',
    des: 'Basic Protect, Light Weight',
    price: 50,
  },
  {
    id: 8,
    category: 'Iphone',
    collab: 'Bts',
    img: img11,
    title: 'BTS Butter Cassette',
    des: 'Basic Protect, Light Weight',
    price: 80,
  },
  {
    id: 9,
    category: 'Samsung Galaxy / Android',
    collab: 'Bts',
    img: img12,
    title: 'BTS Butter Package',
    des: 'Basic Protect, Light Weight',
    price: 80,
  },
  {
    id: 10,
    category: 'Samsung Galaxy / Android',
    collab: 'Bts',
    img: img13,
    title: 'BTS Samsung Pancake',
    des: 'Basic Protect, Light Weight',
    price: 80,
  },
  {
    id: 11,
    category: 'Iphone',
    collab: 'Toy',
    img: img25,
    title: 'OOO Alien Medley Case',
    des: 'Basic Protect, Light Weight',
    price: 80,
  },
  {
    id: 12,
    category: 'Samsung Galaxy / Android',
    collab: 'Toy',
    img: img26,
    title: 'Slinky Medley Case',
    des: 'Strong Protect, Light Weight',
    price: 80,
  },
  {
    id: 13,
    category: 'Iphone',
    collab: 'Toy',
    img: product4,
    title: 'BTS Samsung Pancake',
    des: 'Basic Protect, Light Weight',
    price: 80,
  },
  {
    id: 14,
    category: 'Iphone',
    collab: 'Toy',
    img: img28,
    title: 'Buzz Friend Case',
    des: 'Basic Protect, Light Weight',
    price: 80,
  },
  {
    id: 15,
    category: 'Samsung Galaxy / Android',
    collab: 'Toy',
    img: img27,
    title: 'Yee Haw Jessie Case',
    des: 'Recycled Case, Strong Protect',
    price: 287,
  },
  {
    id: 16,
    category: 'Iphone',
    collab: 'Piece',
    img: product6,
    title: 'Brotherhood Sticker Case',
    des: 'Strong Protection, Light weight',
    price: 287,
  },
  {
    id: 17,
    category: 'Iphone',
    collab: 'Piece',
    img: img29,
    title: 'Thousand Sunny Ship Case',
    des: 'Recycled Case, Strong Protect',
    price: 287,
  },
  {
    id: 18,
    category: 'Iphone',
    collab: 'Piece',
    img: img30,
    title: 'One Piece Branded',
    des: 'Recycled Case, Strong Protect',
    price: 287,
  },
  {
    id: 19,
    category: 'Samsung Galaxy / Android',
    collab: 'Piece',
    img: img31,
    title: 'Poker Card Law & Corazon Case',
    des: 'Strong Case, Strong Protect',
    price: 287,
  },
  {
    id: 20,
    category: 'Iphone',
    collab: 'Piece',
    img: img32,
    title: 'RED Logo Case',
    des: 'Recycled Case, Strong Protect',
    price: 287,
  },
  {
    id: 21,
    category: 'Iphone',
    collab: 'Potter',
    img:"https://cdn-image02.casetify.com/usr/4787/34787/~v3/26590723x2_iphone-14-pro__color_white_16004920.png.1000x1000-w.m80.jpg",
    title: 'House Slytherin Sticker Case',
    des: 'Strong Protect, Light Elective',
    price: 287,
  },
  {
    id: 22,
    category: 'Iphone',
    collab: 'Potter',
    img: "https://cdn-image02.casetify.com/usr/4787/34787/~v1/26590411x2_iphone-14-pro__color_white_16004904.png.1000x1000-w.m80.jpg",
    title: 'House Gryffindor Sticker Case',
    des: 'Recycled Case, Strong Protect',
    price: 287,
  },
  {
    id: 23,
    category: 'Iphone',
    collab: 'Potter',
    img: "https://cdn-image02.casetify.com/usr/4787/34787/~v2/26590688x2_iphone-14-pro__color_black_16004924.png.1000x1000-w.m80.jpg",
    title: 'House Ravenclaw Sticker Case',
    des: 'Recycled Case, Strong Protect',
    price: 287,
  },
  {
    id: 24,
    category: 'Iphone',
    collab: 'Potter',
    img: "https://cdn-image02.casetify.com/usr/4787/34787/~v1/27188137x2_iphone-14-pro__color_white_16004916.png.1000x1000-w.m80.jpg",
    title: 'House Hufflepuff Sticker Case',
    des: 'Recycled Case, Strong Protect',
    price: 287,
  },
  {
    id: 25,
    category: 'Galaxy S22 Ultra',
    collab: 'Potter',
    img: "https://cdn-image02.casetify.com/usr/4787/34787/~v1/27188050x2_samsung-galaxy-s22-ultra__color_black_16004203.png.1000x1000-w.m80.jpg",
    title: 'Honeydukes Goodie Bag Case',
    des: 'Recycled Case, Strong Protect',
    price: 287,
  },
  {
    id: 26,
    category: 'Iphone 12',
    collab: 'Peanuts',
    img: "https://cdn-image02.casetify.com/usr/4787/34787/~v10/23204793x2_iphone-14-pro__color_white_16004733.png.1000x1000-w.m80.jpg",
    title: 'Charlie Brown Good Grief Taffy Case',
    des: 'Magsafe Compatible Impact Case',
    price: 80,
  },
  {
    id: 27,
    category: 'Iphone 13',
    collab: 'Peanuts',
    img: "https://ctgimage1.s3.amazonaws.com/cms/image/d1c1c31fd66a53e1068ecb8af42aeaff.png",
    title: 'Snoopy Plush Case',
    des: 'Plush Case',
    price: 80,
  },
  {
    id: 28,
    category: 'Galaxy Z Flip3',
    collab: 'Peanuts',
    img: "https://cdn-image02.casetify.com/usr/4787/34787/~v1/23534807x2_samsung-galaxy-z-flip-3__color_purple_16004405.png.1000x1000-w.m80.jpg",
    title: 'Bossy Lucy Bubble Gum Case',
    des: 'Impact Cases',
    price: 80,
  },
  {
    id: 29,
    category: 'Iphone 13 Pro',
    collab: 'Peanuts',
    img: "https://ctgimage1.s3.amazonaws.com/cms/image/f9322dae941e2c2b5bb224a1d113455f.png",
    title: 'Woodstock Plush Case',
    des: 'Plush Case',
    price: 80,
  },
  {
    id: 30,
    category: 'Ihoone 14 Pro',
    collab: 'Peanuts',
    img: "https://cdn-image02.casetify.com/usr/4787/34787/~v3/22690699x2_iphone-14-pro__color_white_16004890.png.1000x1000-w.m80.jpg",
    title: 'Linus Pops Candy Case',
    des: 'Impact Cases',
    price: 80,
  },
  {
    id: 31,
    category: 'Galaxy S22 Ultra',
    collab: 'Aespa',
    img: "https://cdn-image02.casetify.com/usr/4787/34787/~v1/27430560x2_iphone-14-pro_16004737.png.1000x1000-w.m80.jpg",
    title: 'MagSafe Compatible Impact Case',
    des: 'Impact Cases',
    price: 80,
  },
  {
    id: 32,
    category: 'Galaxy Z Flip4',
    collab: 'Aespa',
    img: "https://cdn-image02.casetify.com/usr/4787/34787/~v1/28131552x2_samsung-galaxy-z-flip4__color_blue_16005132.png.1000x1000-w.m80.jpg",
    title: 'Aespa Kwangya Sticker Case',
    des: 'Impact Cases',
    price: 80,
  },
  {
    id: 33,
    category: 'Iphone 14 Pro',
    collab: 'Aespa',
    img: "https://cdn-image02.casetify.com/usr/4787/34787/~v1/28061641x2_iphone-14-pro__color_black_16004766.png.1000x1000-w.m80.jpg",
    title: 'Aespa Winter Lyrics Case',
    des: 'Impact Cases',
    price: 80,
  },
  {
    id: 34,
    category: 'Iphone 14 Pro',
    collab: 'Blackpink',
    img: "https://cdn-image02.casetify.com/usr/4787/34787/~v1/26221959x2_iphone-14-pro__color_black_16004725.png.1000x1000-w.m80.jpg",
    title: 'BLACKPINK Diary Stickers Case',
    des: 'Strong Protection, Light weight',
    price: 400,
  },
  {
    id: 35,
    category: 'Galaxy S22 Ultra',
    collab: 'Blackpink',
    img: "https://cdn-image02.casetify.com/usr/4787/34787/~v1/26385056x2_samsung-galaxy-s22-ultra_16004191.png.1000x1000-w.m80.jpg",
    title: 'BLACKPINK Diary Stickers Case',
    des: 'Strong Protection, Light weight',
    price: 450,
  },
  {
    id: 36,
    category: 'Galaxy S22 Ultra',
    collab: 'Blackpink',
    img: "https://cdn-image02.casetify.com/usr/4787/34787/~v1/26603918x2_iphone-14-pro__color_white_16004766.png.1000x1000-w.m80.jpg",
    title: 'BLACKPINK Pink Venom',
    des: 'Strong Protection, Light weight',
    price: 450,
  },
  {
    id: 37,
    category: 'Ihone 14',
    collab: 'Kakao',
    img: "https://cdn-image02.casetify.com/usr/4787/34787/~v10/17911465x2_iphone12-pro-max_16001566.png.1000x1000-w.m80.jpg",
    title: 'Kakao | SummerTime Ryan',
    des: 'Strong Protection, Light weight',
    price: 242,
  },
  {
    id: 38,
    category: 'Ihone 14',
    collab: 'Kakao',
    img: "https://cdn-image02.casetify.com/usr/4787/34787/~v3/17997569x2_iphone12-pro-max__color_black_16001566.png.1000x1000-w.m80.jpg",
    title: 'Kakao | Sticker Friends',
    des: 'Strong Protection, Light weight',
    price: 242,
  },
  {
    id: 39,
    category: 'Ihone 14',
    collab: 'Kakao',
    img: "https://cdn-image02.casetify.com/usr/4787/34787/~v3/17997614x2_iphone12-pro-max__color_gold_16001566.png.1000x1000-w.m80.jpg",
    title: 'Kakao | Friends Beach Day',
    des: 'Strong Protection, Light weight',
    price: 242,
  },
  {
    id: 40,
    category: 'Ihone 14',
    collab: 'Kakao',
    img: "https://cdn-image02.casetify.com/usr/4787/34787/~v3/17911260x2_iphone12-pro-max__color_black_16001566.png.1000x1000-w.m80.jpg",
    title: 'Kakao | Surfing Friends',
    des: 'Strong Protection, Light weight',
    price: 268,
  },
  {
    id: 41,
    category: 'Ihone 14',
    collab: 'Kakao',
    img: "https://cdn-image02.casetify.com/usr/4787/34787/~v9/18686116x2_samsung-galaxy-s21__color_purple_16002425.png.1000x1000-w.m80.jpg",
    title: 'Kakao | Surfing Ryan',
    des: 'Strong Protection, Light weight',
    price: 278,
  },
  {
    id: 42,
    category: 'Iphone 14 Pro',
    collab: 'illustrata',
    img: "https://cdn-image02.casetify.com/usr/13458/22693458/~v32/26151414x2_iphone-14-pro__color_black_16004813.png.1000x1000-w.m80.jpg",
    title: 'Black Coffee Kaiju',
    des: 'Strong Protection, Light Weight',
    price: 328,
  },
  {
    id: 43,
    category: 'Iphone 14 Pro',
    collab: 'illustrata',
    img: "https://cdn-image02.casetify.com/usr/13458/22693458/~v55/22018959x2_iphone-14-pro__color_black_16004813.png.1000x1000-w.m80.jpg",
    title: 'Retro Vending Machine',
    des: 'Strong Protection, Light Weight',
    price: 328,
  },
  {
    id: 44,
    category: 'Iphone 14 Pro',
    collab: 'illustrata',
    img: "https://cdn-image02.casetify.com/usr/13458/22693458/~v50/21827724x2_iphone-14-pro__color_white_16004725.png.1000x1000-w.m80.jpg",
    title: 'Black Great Ramen',
    des: 'Ultra Impact Case, Light Weight',
    price: 284,
  },
  {
    id: 45,
    category: 'Iphone 14 Pro',
    collab: 'illustrata',
    img: "https://cdn-image02.casetify.com/usr/13458/22693458/~v46/21827996x2_iphone-14-pro__color_white_16004729.png.1000x1000-w.m80.jpg",
    title: 'Takoyaki Attack',
    des: 'Ultra Impact Case, Light Weight',
    price: 284,
  },
  {
    id: 46,
    category: 'Iphone 14 Pro',
    collab: 'HK',
    img: "https://cdn-image02.casetify.com/usr/7306/19507306/~v24/24709545x2_iphone-14-pro__color_white_16004813.png.1000x1000-w.m80.jpg",
    title: 'HK STREET FOOD',
    des: 'Ultra Impact Case, Light Weight',
    price: 328,
  },
  {
    id: 47,
    category: 'Iphone 14 Pro',
    collab: 'HK',
    img: "https://cdn-image02.casetify.com/usr/7306/19507306/~v55/20471410x2_iphone-14-pro__color_white_16004725.png.1000x1000-w.m80.jpg",
    title: 'Hong Kong Island',
    des: 'Strong Protection, Light Weight',
    price: 328,
  },
  {
    id: 48,
    category: 'Iphone 14 Pro',
    collab: 'HK',
    img: "https://cdn-image02.casetify.com/usr/7306/19507306/~v31/24709615x2_iphone-14-pro__color_black_16004725.png.1000x1000-w.m80.jpg",
    title: 'Yam Cha',
    des: 'Strong Protection, Light Weight',
    price: 328,
  },
  {
    id: 49,
    category: 'Iphone 14 Pro',
    collab: 'HK',
    img: "https://cdn-image02.casetify.com/usr/7306/19507306/~v35/20471470x2_iphone-14-pro__color_black_16004725.png.1000x1000-w.m80.jpg",
    title: 'New Territories',
    des: 'Strong Protection, Light Weight',
    price: 328,
  },
  {
    id: 50,
    category: 'Iphone 14 Pro',
    collab: 'Giselle',
    img: "https://cdn-image02.casetify.com/usr/25793/22885793/~v47/22428796x2_iphone-14-pro__color_black_16004777.png.1000x1000-w.m80.jpg",
    title: 'Last Email',
    des: 'Ultra Compostable Case',
    price: 260,
  },
  {
    id: 51,
    category: 'Iphone 14 Pro',
    collab: 'Giselle',
    img: "https://cdn-image02.casetify.com/usr/25793/22885793/~v34/22447586x2_iphone13-pro_16005144.png.1000x1000-w.m80.jpg",
    title: 'Blankets For Life',
    des: 'Ultra Compostable Case',
    price: 260,
  },
  {
    id: 52,
    category: 'Iphone 14 Pro',
    collab: 'Giselle',
    img: "https://cdn-image02.casetify.com/usr/25793/22885793/~v1/27150647x2_iphone-14-pro__color_black_16004813.png.1000x1000-w.m80.jpg",
    title: 'No Please',
    des: 'Ultra Compostable Case',
    price: 260,
  },
  {
    id: 53,
    category: 'Iphone 14 Pro',
    collab: 'Giselle',
    img: "https://cdn-image02.casetify.com/usr/25793/22885793/~v1/28111518x2_iphone-14-pro_16004813.png.1000x1000-w.m80.jpg",
    title: 'Doing Nothing',
    des: 'Ultra Compostable Case',
    price: 260,
  },
  {
    id: 54,
    category: 'Iphone 14 Pro',
    collab: 'Sam',
    img: "https://cdn-image02.casetify.com/usr/29215/24959215/~v34/23602876x2_iphone13-pro__color_green_16005144.png.1000x1000-w.m80.jpg",
    title: 'Silly Little Bits',
    des: 'Ultra Compostable Case',
    price: 260,
  },
  {
    id: 55,
    category: 'Iphone 14 Pro',
    collab: 'Sam',
    img: "https://cdn-image02.casetify.com/usr/29215/24959215/~v1/27021089x2_iphone-14-pro__color_white_16004725.png.1000x1000-w.m80.jpg",
    title: 'Barbed Worm',
    des: 'Ultra Compostable Case',
    price: 260,
  },
  {
    id: 56,
    category: 'Iphone 14 Pro',
    collab: 'Sam',
    img: "https://cdn-image02.casetify.com/usr/29215/24959215/~v1/27021147x2_iphone-14-pro__color_black_16004813.png.1000x1000-w.m80.jpg",
    title: 'Tattoo Skull',
    des: 'Ultra Compostable Case',
    price: 260,
  },
  {
    id: 57,
    category: 'Iphone 14 Pro',
    collab: 'Sam',
    img: "https://cdn-image02.casetify.com/usr/29215/24959215/~v26/23708075x2_iphone13-pro__color_blue_16003508.png.1000x1000-w.m80.jpg",
    title: 'Peace Drips',
    des: 'Ultra Compostable Case',
    price: 260,
  },
  {
    id: 58,
    category: 'Iphone 14 Pro',
    collab: 'gia',
    img: "https://cdn-image02.casetify.com/usr/4589/28234589/~v23/26172450x2_iphone-14-pro__color_white_16004725.png.1000x1000-w.m80.jpg",
    title: 'Leaf Me Alone',
    des: 'Ultra Compostable Case',
    price: 260,
  },
  {
    id: 59,
    category: 'Iphone 14 Pro',
    collab: 'gia',
    img: "https://cdn-image02.casetify.com/usr/4589/28234589/~v24/26285783x2_iphone-14-pro__color_white_16004813.png.1000x1000-w.m80.jpg",
    title: 'Green Thumb',
    des: 'Ultra Compostable Case',
    price: 260,
  },
  {
    id: 60,
    category: 'Iphone 14 Pro',
    collab: 'gia',
    img: "https://cdn-image02.casetify.com/usr/4589/28234589/~v20/26285894x2_iphone-14-pro__color_white_16004813.png.1000x1000-w.m80.jpg",
    title: 'Desert Garden',
    des: 'Ultra Compostable Case',
    price: 260,
  },
  {
    id: 61,
    category: 'Samsung Galaxy Z Flip 4',
    collab: 'gia',
    img: "https://cdn-image02.casetify.com/usr/4589/28234589/~v23/26172450x2_samsung-galaxy-z-flip4__color_blue_16004965.png.1000x1000-w.m80.jpg",
    title: 'Leaf Me Alone',
    des: 'Ultra Compostable Case',
    price: 260,
  },
]